import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './RedefinirSenha.module.css';
import logo from '../assets/images/logo_old.png';
import { useSearchParams } from 'react-router-dom';

function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // Captura o valor do token na query string
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  // Regras de validação
  const [validationRules, setValidationRules] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });

  // Atualiza as regras conforme o usuário digita
  useEffect(() => {
    setValidationRules({
      length: newPassword.length >= 8,
      uppercase: /[A-Z]/.test(newPassword),
      lowercase: /[a-z]/.test(newPassword),
      number: /\d/.test(newPassword),
      specialChar: /[@#$%^&+=]/.test(newPassword),
    });
  }, [newPassword]);

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmNewPasswordChange = (e) => {
    setConfirmNewPassword(e.target.value);
  };

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(null);
      }, 30000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmNewPassword) {
      setError('As novas senhas não coincidem.');
      return;
    }

    // Verifica se todas as regras foram atendidas
    if (!Object.values(validationRules).every((rule) => rule)) {
      setError('Por favor, atenda a todos os critérios de segurança da senha.');
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/hello-sol/redefinir-senha/${token}`, {
        method: 'POST', // Endpoint para redefinir senha
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          newPassword: newPassword,
        }),
      });

      if (response.ok) {
        setMessage('Senha alterada com sucesso!');
        setError(null);
        setTimeout(() => navigate('/login'), 3000); // Redireciona para a tela de login após 3 segundos
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao redefinir a senha.');
      }
    } catch (error) {
      console.error('Erro ao fazer a requisição:', error.message);
      setError(error.message);
      setMessage(null);
    }
  };

  useEffect(() => {
    console.log('Token recebido:', token);
  }, [token]);


  return (
      <div className={styles.redefinirSenhaContainer}>
        <div className={styles.redefinirSenhaContent}>
          <div className={styles.redefinirSenhaLogoContainer}>
            <a href="/">
              <img src={logo} alt="Hello Sol" />
            </a>
          </div>
          <h2>Redefinir Senha</h2>
          {message && <p className={styles.successMessage}>{message}</p>}
          {error && <p className={styles.errorMessage}>{error}</p>}
          <form onSubmit={handleSubmit}>
            <div>
              <input
                  type="password"
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                  placeholder="Nova Senha"
                  maxLength="30"
              />
            </div>
            <div>
              <input
                  type="password"
                  value={confirmNewPassword}
                  onChange={handleConfirmNewPasswordChange}
                  placeholder="Confirmar Nova Senha"
                  maxLength="30"
              />
            </div>
            <div className={styles.validationRules}>
              <table className={styles.validationTable}>
                <tbody>

                <tr>
                  <td className={validationRules.length ? 'valid' : 'invalid'}>✅ Pelo menos 8 caracteres</td>
                </tr>
                <tr>
                  <td className={validationRules.uppercase ? 'valid' : 'invalid'}>✅ Pelo menos 1 letra maiúscula</td>
                </tr>
                <tr>
                  <td className={validationRules.lowercase ? 'valid' : 'invalid'}>✅ Pelo menos 1 letra minúscula</td>
                </tr>
                <tr>
                  <td className={validationRules.number ? 'valid' : 'invalid'}>✅ Pelo menos 1 número</td>
                </tr>
                <tr>
                  <td className={validationRules.specialChar ? 'valid' : 'invalid'}>✅ Pelo menos 1 caractere especial
                    (@#$%^&+=)
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <button type="submit">Redefinir Senha</button>
          </form>
        </div>
      </div>
  );
}

export default RedefinirSenha;
